import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { END_TO_END_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useGroupKey } from '../../../hooks/task';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_MANAGE_USERS_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InviteTeamModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('InviteTeamModal');
  const groupKey = useGroupKey();
  const modalI18nPrefix = useMemo(() => {
    if (groupKey === END_TO_END_GROUP_KEYS.salesStarter || groupKey === END_TO_END_GROUP_KEYS.experiencedCrmLeader || groupKey === END_TO_END_GROUP_KEYS.inexperiencedCrmLeader) {
      return 'setup-guide-components.modal.inviteSalesTeam';
    }
    return 'setup-guide-components.modal.inviteTeam';
  }, [groupKey]);
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    footer: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('manage users article'),
      url: KNOWLEDGE_BASE_MANAGE_USERS_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${modalI18nPrefix}.heading`
    }),
    illustrationName: "team",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${modalI18nPrefix}.description`
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: `${modalI18nPrefix}.li1`
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: `${modalI18nPrefix}.li2`
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: `${modalI18nPrefix}.li3`
    })]
  });
};
InviteTeamModal.propTypes = {
  onClose: PropTypes.func
};
export default InviteTeamModal;